import { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useUserInfoStore } from '~/stores/userInfo';
import useAppNavigation from './useAppNavigation';
import useToast from './useToast';
import usecredsystemDataStore from '~/credsystem/stores/credsystemData';
import useCredsystemAuthStore from '~/credsystem/stores/credsystemAuth';
import initCredsystemUser from '~/credsystem/hooks/initCredsystemUser';

const DEFAULT_INACTIVITY_TOTEM_IN_SECONDS = 120;

export const useWebIdler = (active: boolean) => {
  const { showModalAlertIdle, hideToast } = useToast();
  const navigation = useAppNavigation();

  const onIdle = async () => {
    hideToast();
    await useUserInfoStore.getState().logout();
    usecredsystemDataStore.getState().clear();
    await useCredsystemAuthStore.getState().logout();
    initCredsystemUser();
    navigation.navigate('MarisaServicos_Home');
  };

  const onPrompt = () => {
    showModalAlertIdle({ autoHide: false });
  };

  const onAction = () => {
    if (isPrompted()) {
      hideToast();
      start();
    }
  };

  const { start, isPrompted } = useIdleTimer({
    timeout: DEFAULT_INACTIVITY_TOTEM_IN_SECONDS * 1000,
    startManually: true,
    stopOnIdle: false,
    onIdle: onIdle,
    onPrompt: onPrompt,
    onAction: (ev) => {
      if (ev?.type !== 'focus') onAction();
    },
    promptBeforeIdle: 20 * 1000,
  });

  useEffect(() => {
    if (active) {
      start();
    }
  }, [active, start]);
};
